import { HttpRequestError } from '../../types';
import {
  ActionType,
  ManagementReportRequestedAction,
  ManagementReportSuccessAction,
  ManagementReportFailureAction,
  ManagementChangeFilterCountryAction,
  ManagementChangeFilterDateAction,
  ManagementReportEntry,
} from './types';

export const managementReportRequested = (): ManagementReportRequestedAction => ({
  type: ActionType.managementReportRequested,
});

export const managementReportSuccess = (
  data: ManagementReportEntry[]
): ManagementReportSuccessAction => ({
  type: ActionType.managementReportSuccess,
  data,
});

export const managementReportFailure = (
  error: HttpRequestError
): ManagementReportFailureAction => ({
  type: ActionType.managementReportFailure,
  error,
});

export const managementChangeFilterCountry = (
  countryCode: string
): ManagementChangeFilterCountryAction => ({
  type: ActionType.managementChangeFilterCountry,
  countryCode,
});

export const managementChangeFilterStartDate = (
  date: Date | null
): ManagementChangeFilterDateAction => ({
  type: ActionType.managementChangeFilterStartDate,
  date,
});

export const managementChangeFilterEndDate = (
  date: Date | null
): ManagementChangeFilterDateAction => ({
  type: ActionType.managementChangeFilterEndDate,
  date,
});
